import { Modal } from 'antd';
import React from 'react';

import './ConfirmModal.css';

const ConfirmModal = ({ visible, handleOk, handleCancel, text }) => {
  return (
    <div className='change-page-modal'>
      <Modal
        className='page-modal'
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{
          children: 'OK'
        }}
        cancelButtonProps={{
          children: 'Cancel'
        }}
      >
        <p>{text}</p>
      </Modal>
    </div>
  );
};

export default ConfirmModal;
